$('.is-style-team .wp-block-buttons .wp-block-button').on('click', function() {
  $(this).parent().parent().toggleClass('active');
  $(this).find('.wp-block-button__link').text() === 'Read More' ? $(this).find('.wp-block-button__link').text('Read Less') : $(this).find('.wp-block-button__link').text('Read More');
});
